import { render, staticRenderFns } from "./ModalCriarEditarItemTabelaPrecoProcedimento.vue?vue&type=template&id=cc1b220a&scoped=true"
import script from "./ModalCriarEditarItemTabelaPrecoProcedimento.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarItemTabelaPrecoProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarItemTabelaPrecoProcedimento.vue?vue&type=style&index=0&id=cc1b220a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1b220a",
  null
  
)

export default component.exports